import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=246c1462&"
import script from "./CreateGroup.vue?vue&type=script&lang=js&"
export * from "./CreateGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports